import ImportTool from "components/tools/import-tool/ImportTool";
import { useExternalTrainingContext } from "api/datatrack/external-training/ExternalTrainingProvider";
import { useState } from "react";
import {
  TRAINING_MAX_FILE_SIZE,
} from "constants/constants";
import AlertPopup from "components/alert-popup/AlertPopup";

const Training = () => {
  const {
    uploadExternalTrainingByUserId,
    uploadExternalTrainingStatus,
    setUploadExternalTrainingStatus,
    progression,
    setProgression,
    serverResponse,
    setServerResponse,
  } = useExternalTrainingContext();
  const [code, setCode] = useState();
  const [status, setStatus] = useState();

  return (
    <>
      <AlertPopup
        code={code}
        setCode={setCode}
        setStatus={setStatus}
        status={status}
      />
      <ImportTool
        queryStatus={uploadExternalTrainingStatus}
        query={uploadExternalTrainingByUserId}
        setQueryStatus={setUploadExternalTrainingStatus}
        progression={progression}
        setProgression={setProgression}
        setCode={setCode}
        setStatus={setStatus}
        serverResponse={serverResponse}
        setServerResponse={setServerResponse}
        fileSizeLimit={TRAINING_MAX_FILE_SIZE}
      />
    </>
  );
};

export default Training;
